var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "li",
    { class: { handle: _vm.editMode } },
    [
      _c(
        "w-link",
        {
          staticClass: "link",
          on: {
            click: function ($event) {
              return _vm.onClick()
            },
          },
        },
        [
          _vm.editMode
            ? _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("delete-button"),
                      expression: "$ct('delete-button')",
                    },
                  ],
                  staticClass: "danger delete-button",
                  attrs: { round: "", sm: "" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteButton()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "trash" } })],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "icon-container" },
            [
              _c("w-fa", {
                staticClass: "icon",
                attrs: { icon: _vm.button.getIcon() },
              }),
            ],
            1
          ),
          _c("span", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.button.getLabel())),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }